import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-form-side-switcher" }

import { computed, type PropType } from 'vue';

import { orderformService } from '@exchange/libs/order/order-form/service/src';
import { OrderSide } from '@exchange/libs/order/shared-model/src/lib/order-essentials';

import orderFormEmitter from './order-form-event-bus';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFormSideSwitcher',
  props: {
  onActiveSideChange: { type: Function as PropType<(type: OrderSide) => void>, required: false },
  activeSide: { type: String as PropType<OrderSide>, required: false },
  isFutures: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;

const storedSide = computed(() => props.activeSide ?? orderformService.data.side);
const isBuyOrder = computed(() => storedSide.value === OrderSide.BUY);

const onChange = (incomingSide: OrderSide) => {
  if (storedSide.value !== incomingSide) {
    orderformService.setSide(incomingSide);
    orderFormEmitter.emit('reset-form-softly');
  }

  if (props.onActiveSideChange) {
    props.onActiveSideChange(incomingSide);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_x_button, {
      class: _normalizeClass(["order-form-side-switcher__button order-form-side-switcher__button--left", { 'order-form-side-switcher__button--underlined': isBuyOrder.value, 'order-form-side-switcher__button--base': !isBuyOrder.value }]),
      size: "xs",
      rounded: "sm",
      variant: isBuyOrder.value ? 'underlined-success' : 'base',
      text: __props.isFutures ? `${_ctx.$t('fundamentals.orders.side.buy')} / ${_ctx.$t('fundamentals.orders.side.long')}` : _ctx.$t('fundamentals.orders.side.buy'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onChange(_unref(OrderSide).BUY)))
    }, null, 8, ["class", "variant", "text"]),
    _createVNode(_component_x_button, {
      class: _normalizeClass(["order-form-side-switcher__button order-form-side-switcher__button--right", { 'order-form-side-switcher__button--underlined': !isBuyOrder.value, 'order-form-side-switcher__button--base': isBuyOrder.value }]),
      size: "xs",
      rounded: "sm",
      variant: !isBuyOrder.value ? 'underlined-error' : 'base',
      text: __props.isFutures ? `${_ctx.$t('fundamentals.orders.side.sell')} / ${_ctx.$t('fundamentals.orders.side.short')}` : _ctx.$t('fundamentals.orders.side.sell'),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onChange(_unref(OrderSide).SELL)))
    }, null, 8, ["class", "variant", "text"])
  ]))
}
}

})